<template>
  <div>
    <div class="container mt-3">
      <div class="row d-flex justify-content-center">
        <div class="col-md-9">
          <div id="div-cxc" class="card w-100 mb-lg-5 text-center">
            <div class="card-header text-white bg-main h4">
              <div style="position: relative">
                <div class="">
                  <strong>ORDEN DE TRABAJO</strong>
                </div>
                <div
                  class="btn-home-jefatura"
                  style="right: 0; top: 0; position: absolute"
                >
                  <button type="button" class="btn btn-sm" @click="retroceder">
                    <i class="fas fa-home-lg-alt"></i> Inicio
                  </button>
                </div>
              </div>
            </div>
            <div class="card-body">
              <div class="row d-flex">
                <div class="col-md-12 mb-2">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >DOCTOR
                  </label>
                  <select
                    class="form-control form-control-sm mb-1"
                    v-model="orden.doctor_id"
                  >
                    <option value="0">Seleccione Doctor</option>
                    <option
                      v-for="(item, index) in doctor"
                      :key="index"
                      :value="item.id"
                    >
                      {{ item.name }} {{ item.last_name }}
                    </option>
                  </select>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-12 mb-2">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >NOMBRE
                  </label>
                  <input
                    v-model="client.fullName"
                    type="text"
                    class="form-control form-control-sm"
                    readonly
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 mb-1">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >TELÉFONO
                  </label>
                  <input
                    v-model="client.celphone"
                    type="text"
                    class="form-control form-control-sm"
                    readonly
                  />
                </div>
                <div class="col-xl-3 col-lg-3 col-md-6 mb-1">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >N° DOCUMENTO
                  </label>
                  <input
                    v-model="client.document"
                    type="text"
                    class="form-control form-control-sm"
                    readonly
                  />
                </div>
                <div class="col-md-2 mt-1 mb-1">
                  <!-- <div
                    class="form-check form-switch justify-content-start mb-3"
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      role="switch"
                      id="flexSwitchCheckCheckedInput"
                      v-model="orden.input_state"
                      :checked="orden.input_state == true"
                      aria-checked="false"
                      :class="{ 'input-switch': orden.input_state }"
                      @change="handleInputStateChange"
                    />
                    <label
                      class="form-check-label fw-bold"
                      :class="{ 'input-switch': orden.input_state }"
                      for="flexSwitchCheckCheckedInput"
                    >
                      {{ orden.input_state ? "MANUAL" : "AUTOMATICO" }}
                    </label>
                  </div> -->
                </div>
              </div>
              <div class="row mt-1">
                  <div class="table-responsive mb-2">
                      <table class="table table-bordered">
                      <thead>
                          <tr>
                          <th colspan="6" class="text-center bg-main text-white">
                              MEDIDA LEJOS
                          </th>
                          <th colspan="6" class="text-center bg-main text-white">
                              MEDIDA CERCA
                          </th>
                          </tr>
                      </thead>
                      <tbody>
                          <tr>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 160px; text-align: left"
                                  >OD</strong
                              >
                              <input
                                  v-model="orden.measure.far.od"
                                  type="text"
                                  class="form-control form-control-sm w-100 text-center"
                              />
                              </div>
                          </td>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 160px; text-align: left"
                                  >OD</strong
                              >
                              <input
                                  v-model="orden.measure.near.od"
                                  type="text"
                                  class="form-control form-control-sm w-100 text-center"
                              />
                              </div>
                          </td>
                          </tr>
                          <tr>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 160px; text-align: left"
                                  >OI</strong
                              >
                              <input
                                  v-model="orden.measure.far.oi"
                                  type="text"
                                  class="form-control form-control-sm w-100 text-center"
                              />
                              </div>
                          </td>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 160px; text-align: left"
                                  >OI</strong
                              >
                              <input
                                  v-model="orden.measure.near.oi"
                                  type="text"
                                  class="form-control form-control-sm w-100 text-center"
                              />
                              </div>
                          </td>
                          </tr>
                          <tr>
                            <td colspan="6">
                                <div class="d-flex align-items-center">
                                <strong
                                    class="me-3 space"
                                    style="width: 160px; text-align: left"
                                    >DIP</strong
                                >
                                <input
                                    v-model="orden.measure.far.dip"
                                    type="text"
                                    class="form-control form-control-sm w-100 text-center"
                                />
                                </div>
                            </td>
                            <td colspan="6">
                                <div class="d-flex align-items-center">
                                <strong
                                    class="me-3 space"
                                    style="width: 160px; text-align: left"
                                    >DIP</strong
                                >
                                <input
                                    v-model="orden.measure.near.dip"
                                    type="text"
                                    class="form-control form-control-sm w-100 text-center"
                                />
                                </div>
                            </td>
                          </tr>
                          <tr v-if="orden.input_state == false">
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 165px; text-align: left"
                                  >TIPO DE LUNA</strong
                              >
                              <input
                                  v-model="orden.measure.far.search_lensType"
                                  type="text"
                                  class="form-control form-control-sm w-25 text-center me-1"
                                  placeholder="Buscar"
                                  @keyup.enter="
                                  mtdAddLunas(1, orden.measure.far.search_lensType)
                                  "
                              />
                              <input
                                  v-model="orden.measure.far.lensType"
                                  type="text"
                                  class="form-control form-control-sm w-75 text-center"
                                  placeholder="Tipo de Luna"
                                  disabled
                              />
                              </div>
                          </td>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 165px; text-align: left"
                                  >TIPO DE LUNA</strong
                              >
                              <input
                                  v-model="orden.measure.near.search_lensType"
                                  type="text"
                                  class="form-control form-control-sm w-25 text-center me-1"
                                  placeholder="Buscar"
                                  @keyup.enter="
                                  mtdAddLunas(2, orden.measure.near.search_lensType)
                                  "
                              />
                              <input
                                  v-model="orden.measure.near.lensType"
                                  type="text"
                                  class="form-control form-control-sm w-75 text-center"
                                  placeholder="Tipo de Luna"
                                  disabled
                              />
                              </div>
                          </td>
                          </tr>
                          <tr v-else>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 160px; text-align: left"
                                  >TIPO DE LUNA</strong
                              >
                              <input
                                  v-model="orden.measure.far.lensType"
                                  type="text"
                                  class="form-control form-control-sm w-100 text-center"
                              />
                              </div>
                          </td>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 160px; text-align: left"
                                  >TIPO DE LUNA</strong
                              >
                              <input
                                  v-model="orden.measure.near.lensType"
                                  type="text"
                                  class="form-control form-control-sm w-100 text-center"
                              />
                              </div>
                          </td>
                          </tr>
                          <tr>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 160px; text-align: left"
                                  >NOTA</strong
                              >
                              <textarea
                                  v-model="orden.measure.far.note"
                                  class="form-control form-control-sm w-100 text-center"
                                  rows="2"
                              ></textarea>
                              </div>
                          </td>
                          <td colspan="6">
                              <div class="d-flex align-items-center">
                              <strong
                                  class="me-3 space"
                                  style="width: 160px; text-align: left"
                                  >NOTA</strong
                              >
                              <textarea
                                  v-model="orden.measure.near.note"
                                  class="form-control form-control-sm w-100 text-center"
                                  rows="2"
                              ></textarea>
                              </div>
                          </td>
                          </tr>
                      </tbody>
                      </table>
                  </div>
              </div>
              <div class="row d-flex mb-2">
                <div class="col-md-4 mb-1">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >TOTAL
                  </label>
                  <input
                    v-model="orden.measure.payment.total"
                    type="text"
                    class="form-control form-control-sm text-center"
                    @keydown="filterKey"
                    @input="calculateSaldo"
                    :readonly="orden.input_state === false"
                  />
                </div>
                <div class="col-md-4 mb-1">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >A CUENTA
                  </label>
                  <input
                    v-model="orden.measure.payment.advance"
                    type="text"
                    class="form-control form-control-sm text-center"
                    @keydown="filterKey"
                    @input="calculateSaldo"
                    placeholder="0"
                  />
                </div>
                <div class="col-md-4 mb-1">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >SALDO
                  </label>
                  <input
                    v-model="orden.measure.payment.balance"
                    type="text"
                    class="form-control form-control-sm text-center"
                    @keydown="filterKey"
                    readonly
                  />
                </div>
              </div>
              <div class="row">
                  <div class="table-responsive mb-2 mt-3">
                    <table class="table table-bordered">
                      <thead>
                        <tr>
                          <th colspan="12" class="bg-main text-white">
                            <div
                              class="d-flex justify-content-between align-items-center"
                            >
                              <span class="mx-auto">MONTURAS MODELO</span>
                              <div class="form-check form-switch">
                                <input
                                  class="form-check-input"
                                  type="checkbox"
                                  role="switch"
                                  id="flexSwitchCheckChecked"
                                  v-model="orden.client_state"
                                  :checked="orden.client_state == true"
                                  aria-checked="false"
                                  :class="{ 'checked-switch': orden.client_state }"
                                  @change="handleClientStateChange"
                                />
                                <label
                                  class="form-check-label"
                                  :class="{ 'checked-switch': orden.client_state }"
                                  for="flexSwitchCheckChecked"
                                >
                                  {{
                                    orden.client_state
                                      ? "TRAIDO POR EL CLIENTE"
                                      : "NO ES TRAIDO POR EL CLIENTE"
                                  }}
                                </label>
                              </div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody v-if="orden.client_state == false">
                        <tr v-for="(item, index) in orden.mounts" :key="index">
                          <td colspan="5">
                            <div class="d-flex align-items-center">
                              <strong
                                class="me-3 space"
                                style="width: 160px; text-align: left"
                                >MONTURA {{ index + 1 }}</strong
                              >
                              <input
                                v-model="item.search_mount_name"
                                type="text"
                                class="form-control form-control-sm w-25 text-center me-1"
                                placeholder="Buscar"
                                @keyup.enter="mtdAddMonturas(item, index)"
                              />
                              <input
                                v-model="item.mount_name"
                                type="text"
                                class="form-control form-control-sm w-75 text-center"
                                placeholder="Montura"
                                disabled
                              />
                            </div>
                          </td>
                          <!-- <td colspan="5" v-else>
                            <div class="d-flex align-items-center">
                              <strong
                                class="me-3 space"
                                style="width: 160px; text-align: left"
                                >MONTURA {{ index + 1 }}</strong
                              >
                              <input
                                v-model="item.mount_name"
                                type="text"
                                class="form-control form-control-sm w-100 text-center"
                              />
                            </div>
                          </td> -->
                          <!-- <td colspan="5">
                            <div class="d-flex align-items-center">
                              <strong
                                class="me-3 space"
                                style="width: 160px; text-align: left"
                                >PRECIO</strong
                              >
                              <input
                                v-model="item.mount_price"
                                type="text"
                                class="form-control form-control-sm w-100 text-center"
                                @keydown="filterKey"
                                @input="calculateSumMounts"
                                :readonly="orden.input_state === false"
                              />
                            </div>
                          </td> -->
                          <td colspan="5">
                            <div class="d-flex align-items-center">
                              <strong
                                class="me-3 space"
                                style="width: 160px; text-align: left"
                                >PRECIO</strong
                              >
                              <input
                                v-model="item.mount_price"
                                type="text"
                                class="form-control form-control-sm w-100 text-center"
                                @keydown="filterKey"
                                :disabled="!item.mount_name"
                                @input="calculateSumMounts"
                              />
                            </div>
                          </td>
                          <td v-if="index == orden.mounts.length - 1">
                            <button @click="addRow" class="btn btn-sm btn-success">
                              <span class="button-mount">+</span>
                            </button>
                          </td>
                          <td
                            v-if="orden.mounts.length > 1"
                            :colspan="orden.mounts.length > 1 ? 2 : 1"
                          >
                            <button
                              @click="removeRow(index)"
                              class="btn btn-sm btn-danger"
                            >
                              <span class="button-mount">-</span>
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
              </div>
              <div class="row d-flex mb-2">
                <div class="col-md-4 mb-1">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >TOTAL
                  </label>
                  <input
                    v-model="orden.mounts_payment.total"
                    type="text"
                    class="form-control form-control-sm text-center"
                    @keydown="filterKey"
                    readonly
                    :disabled="orden.client_state"
                  />
                </div>
                <div class="col-md-4 mb-1">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >A CUENTA
                  </label>
                  <input
                    v-model="orden.mounts_payment.advance"
                    type="text"
                    class="form-control form-control-sm text-center"
                    @keydown="filterKey"
                    @input="calculateSaldoMounts"
                    :disabled="orden.client_state"
                    placeholder="0"
                  />
                </div>
                <div class="col-md-4 mb-1">
                  <label class="fw-bold text-start d-block mb-1 payment"
                    >SALDO
                  </label>
                  <input
                    v-model="orden.mounts_payment.balance"
                    type="text"
                    class="form-control form-control-sm text-center"
                    @keydown="filterKey"
                    readonly
                    :disabled="orden.client_state"
                  />
                </div>
              </div>
            </div>
            <div class="card-footer text-end justify-content-end btn-home">
              <button
                class="fw-semibold btn btn-sm btn-primary"
                @click="saveData()"
              >
                <i class="fas fa-save"></i> GUARDAR
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <cModalPaymentVue
      :title="modal.title"
      :boo_modal="modal.modal_form"
      :totalPay="modal.total"
      @closeModal="closeModal"
      @mdtCommitPayment="mtdVerifData"
    />
    <cModalPaymentTotalVue
      :title="modaltotal.title"
      :boo_modal="modaltotal.modal_form"
      :totalPay="modaltotal.total"
      :client="client"
      @closeModaltotal="closeModaltotal"
         @mdtCommitPayment="mtdVerifData"
    />
    <cModalMonturasVue
      :data="data"
      :title="modalMonturas.title"
      :boo_modal="modalMonturas.modal_form"
      :pos="modalMonturas.pos"
      :search="modalMonturas.search"
      @closeModal="closeModalMonturas"
      @add="addMonturas"
    />
    <cModalLunasVue
      :title="modalLunas.title"
      :boo_modal="modalLunas.modal_form"
      :num="modalLunas.num"
      :search="modalLunas.search"
      @closeModal="closeModalLunas"
      @add="addLunas"
    />
    <SweetAlert :swal="swal" ref="SweetAlert" />
  </div>
</template>
  
<script>
import { mapActions } from "vuex";
import SweetAlert from "@/components/shared/SweetAlert/SweetAlert.vue";
import cModalPaymentVue from "@/components/Admision/modal/OrdenTrabajo/cModalPayment.vue";
import cModalMonturasVue from "@/components/Admision/modal/OrdenTrabajo/cModalMonturas.vue";
import cModalLunasVue from "@/components/Admision/modal/OrdenTrabajo/cModalLunas.vue";
import cModalPaymentTotalVue from "@/components/Admision/modal/OrdenTrabajo/cModalPaymentTotal.vue";
export default {
  name: "c-admision-page-orden",
  components: {
    SweetAlert,
    cModalPaymentVue,
    cModalMonturasVue,
    cModalLunasVue,
    cModalPaymentTotalVue
  },
  data() {
    return {
      data: [],
      swal: null,
      page: "orden",
      orden: {
        number: null,
        doctor_id: 0,
        campu_id: this.$store.getters.get__campus,
        measure: {
          far: {
            od: "",
            oi: "",
            lensType: null,
            lensType_id: null,
            lensType_price: 0,
            note: "",
            dip: "",
          },
          near: {
            od: "",
            oi: "",
            lensType: null,
            lensType_id: null,
            lensType_price: 0,
            note: "",
            dip: "",
          },
          payment: {
            total: 0,
            advance: null,
            balance: 0,
          },
        },
        mounts: [
          {
            mount_name: "",
            mount_id: null,
            mount_price: 0,
            dispatch_detail_id: null
          },
        ],
        mounts_payment: {
          total: 0,
          advance: null,
          balance: 0,
        },
        client_state: false,
        input_state: true,
      },
      modal: {
        title: "",
        modal_form: false,
        total: null,
      },
      dataPay: {},
      dataTypeMoon: [],
      dataMont: [],
      modalMonturas: {
        title: "",
        modal_form: false,
        pos: null,
        search: null,
      },
      modalLunas: {
        title: "",
        modal_form: false,
        num: null,
        search: null,
      },
      modaltotal: {
        title: "",
        modal_form: false,
        total: null,
      },
    };
  },
  props: {
    boxes: [],
    bead: {},
    client: {},
    doctor: Array,
  },
  computed: {},
  created() {},
  methods: {
    ...mapActions(["get", "post"]),

    retroceder() {
      this.$emit("mtdChangePage", "home");
    },
    addRow() {
      this.orden.mounts.push({ mount_name: "", mount_price: 0 });
      this.calculateSumMounts();
    },
    removeRow(index) {
      if (this.orden.mounts.length > 1) {
        this.orden.mounts.splice(index, 1);
        this.calculateSumMounts();
      }
    },
    calculateSumMounts() {
      let total = 0;
      this.orden.mounts.forEach((element) => {
        total += parseFloat(element.mount_price) || 0;
      });
      this.orden.mounts_payment.total = total.toFixed(2);
      this.calculateSaldoMounts();
    },

    calculateSaldoMounts() {
      let advance = parseFloat(this.orden.mounts_payment.advance) || 0;
      let total = parseFloat(this.orden.mounts_payment.total) || 0;

      if (total >= advance) {
        this.orden.mounts_payment.balance = (total - advance).toFixed(2);
      } else {
        this.orden.mounts_payment.advance = null;
        this.orden.mounts_payment.balance = total;
      }
    },

    calculateSum() {
      let total =
        parseFloat(this.orden.measure.far.lensType_price || 0) +
        parseFloat(this.orden.measure.near.lensType_price || 0);

      this.orden.measure.payment.total = total.toFixed(2);

      this.calculateSaldo();
    },

    calculateSaldo() {
      let advance = parseFloat(this.orden.measure.payment.advance) || 0;
      let total = parseFloat(this.orden.measure.payment.total) || 0;

      if (total >= advance) {
        this.orden.measure.payment.balance = (total - advance).toFixed(2);
      } else {
        this.orden.measure.payment.advance = null;
        this.orden.measure.payment.balance = total;
      }
    },

    filterKey: function (e) {
      let b = false;
      b = /^[0-9.]$/.test(e.key);
      if (!b && e.key !== "Backspace") {
        e.preventDefault();
      }
    },
    saveData: function () {
      //Validacion Doctor
      if (
        !this.orden.doctor_id || this.orden.doctor_id == 0
      ) {
        this.$refs.SweetAlert.showWarning(
          "Seleccione un Doctor",
          "warning"
        );
        return;
      }

      // Validar que al menos uno de los lensType esté seleccionado
      if (
        !this.orden.measure.far.lensType &&
        !this.orden.measure.near.lensType
      ) {
        this.$refs.SweetAlert.showWarning(
          "Debe seleccionar al menos un Tipo de Luna",
          "warning"
        );
        return;
      }

      // if (parseFloat(this.orden.measure.payment.total) == 0) {
      //   this.$refs.SweetAlert.showWarning(
      //     "El total de Medidas no puede ser 0",
      //     "warning"
      //   );
      //   return;
      // }

      if (!this.orden.client_state) {
        // if (parseFloat(this.orden.mounts_payment.total) == 0) {
        //   this.$refs.SweetAlert.showWarning(
        //     "El total de Monturas no puede ser 0",
        //     "warning"
        //   );
        //   return;
        // }

        // Validar si hay algún mount_name vacío
        let emptyMountName = this.orden.mounts.some(
          (mount) => mount.mount_name.trim() == ""
        );
        if (emptyMountName) {
          this.$refs.SweetAlert.showWarning(
            "Todos los nombres de Monturas deben estar Completos",
            "warning"
          );
          return;
        }
      } else {
        this.orden.mounts = [];
      }
      // Calcular la suma de los advance
      let totalAdvance =
      (parseFloat(this.orden.measure.payment.advance) || 0) +
      (parseFloat(this.orden.mounts_payment.advance) || 0);
      
      let total = parseFloat(this.orden.measure.payment.total) +
      parseFloat(this.orden.mounts_payment.total);

      if(totalAdvance === total ){
        this.modaltotal = {
          title: "PAGOS",
          modal_form: true,
          total: totalAdvance,
        }
      }else{
        if (totalAdvance > 0) {
          this.modal = {
            title: "PAGOS",
            modal_form: true,
            total: totalAdvance,
          };
        } else {
          this.mtdVerifData(this.dataPay);
        }

      }

    },


    mtdVerifData: function (dataPay,
      chkPatiente,
      planilla,
      garantia,
      impuestos,
      selectedVoucherCancel) {
      this.$refs.SweetAlert.showConfirmSimple2(
        "",
        "¿Estás seguro de Guardar estos Datos?",
        "warning",
        "Confirmar"
      ).then((result) => {
        if (result.value) {
          this.mtdSaveData(dataPay,chkPatiente,planilla,
          garantia,
          impuestos,
          selectedVoucherCancel);
        }
      });
    },

    mtdSaveData: function (dataPay,chkPatiente,planilla,
          garantia,
          impuestos,
          selectedVoucherCancel) {

      if (this.orden.mounts_payment.advance == null) {
        this.orden.mounts_payment.advance = 0;
      }

      if (this.orden.measure.payment.advance == null) {
        this.orden.measure.payment.advance = 0;
      }

      if (this.orden.input_state) {
        let total = parseFloat(this.orden.measure.payment.total) || 0;
        let mitadTotal = (total / 2).toFixed(2);

        // Verificar si ambos lensType tienen valores válidos (no null, no vacíos y sin espacios)
        const farLensType = this.orden.measure.far.lensType
          ? this.orden.measure.far.lensType.trim()
          : "";
        const nearLensType = this.orden.measure.near.lensType
          ? this.orden.measure.near.lensType.trim()
          : "";

        if (farLensType && nearLensType) {
          this.orden.measure.far.lensType_price = parseFloat(mitadTotal);
          this.orden.measure.near.lensType_price = parseFloat(mitadTotal);
        } else {
          if (farLensType && !nearLensType) {
            this.orden.measure.far.lensType_price = parseFloat(total);
          } else if (!farLensType && nearLensType) {
            this.orden.measure.near.lensType_price = parseFloat(total);
          }
        }
      }

      this.post({
        url: this.$store.getters.get__url + "/ordenTrabajo",
        token: this.$store.getters.get__token,
        params: {
          data: this.orden,
          client: this.client,
          chkPatiente: chkPatiente,
          dataPay: dataPay,
          bead: this.bead,
          planilla:planilla,
          garantia:garantia,
          impuestos:impuestos,
          selectedVoucherCancel:selectedVoucherCancel
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            if (response.data.data != null) {
              if (response.data.data.document === "TICKET") {
                window.open(
                  this.$store.getters.get__url +
                    "/Admision/ticketOrden/" +
                    response.data.data.id,
                  "_blank"
                );
              }else{
                window.open(response.data.data.sunat.json.enlace_del_pdf_ticket, "_blank");
              }
            }
            this.viewpdfOrdenTrabajo(response.data.order.id);
            this.$refs.SweetAlert.showSuccess("Registrado Correctamente");
            this.$emit("mtdChangePage", "viewOrden")
          }
        })
        .catch((errors) => {
          this.$refs.SweetAlert.showError(errors);
        });
    },


    viewpdfOrdenTrabajo: function (id) {
      window.open(
        this.$store.getters.get__url + "/viewpdfOrdenTrabajo/" + id,
        "_blank"
      );
    },

    handleClientStateChange: function () {
      if (this.orden.client_state === true) {
        this.orden.mounts_payment = {
          total: 0,
          advance: null,
          balance: 0,
        };
        this.orden.mounts = [
          {
            mount_name: "",
            mount_id: null,
            mount_price: 0,
            dispatch_detail_id: null
          },
        ];
      }
    },

    handleInputStateChange: function () {
      this.orden.measure.far.lensType = null;
      this.orden.measure.far.lensType_id = null;
      this.orden.measure.far.lensType_price = 0;

      this.orden.measure.near.lensType = null;
      this.orden.measure.near.lensType_id = null;
      this.orden.measure.near.lensType_price = 0;

      this.orden.mounts_payment = {
        total: 0,
        advance: null,
        balance: 0,
      };
      this.orden.mounts = [
        {
          mount_name: "",
          mount_id: null,
          mount_price: 0,
          dispatch_detail_id: null
        },
      ];
      /* if (this.orden.input_state === false) {
        this.orden.measure.payment = {
          total: 0,
          advance: null,
          balance: 0,
        };
      } */
      this.orden.measure.payment = {
        total: 0,
        advance: null,
        balance: 0,
      };
    },

    //Modals Pago
    closeModal: function () {
      this.modal = {
        title: "",
        modal_form: false,
        total: null,
      };
    },

    //Modal Montura
    mtdAddMonturas: function (item, index) {
      if (item.search_mount_name.length > 2) {
        this.get({
          url:
            this.$store.getters.get__url +
            "/Venta/particular/null/" +
            this.$store.getters.get__campus +
            "/subsubcategories?search_product=" +
            item.search_mount_name,
          token: this.$store.getters.get__token,
        }).then((response) => {
          let data = response.data.data;
          if (data.length == 1 && data[0].typeSearch == "code") {
            this.addMonturas(data[0], index);
          } else {
            this.modalMonturas = {
              title: "Lista de Monturas",
              modal_form: true,
              pos: index,
              search: item.search_mount_name,
            };
            this.data = data;
          }
        });
      } else {
        this.$refs.SweetAlert.showWarning("Digite Montura. Max 3 Caracteres");
      }
    },

    closeModalMonturas: function () {
      this.modalMonturas = {
        title: "",
        modal_form: false,
        pos: null,
        search: null,
      };
    },

    /* addMonturas: function(payload, pos) {
      this.orden.mounts[pos].mount_name = payload.name;
      this.orden.mounts[pos].mount_id = payload.id;
      this.orden.mounts[pos].search_mount_name = '';
      this.orden.mounts[pos].mount_price = payload.precio_farmacia_particular;
      this.orden.mounts[pos].barcode = payload.barcode;
      this.calculateSumMounts();
    }, */
    
    addMonturas: function (payload, pos) {
      // const existeMontura = this.orden.mounts.some(mount => mount.mount_id === payload.id);
      // if (existeMontura) {
      //     this.$refs.SweetAlert.showWarning("La montura ya está en el carrito y no se puede agregar nuevamente");
      //     return;
      // }

      // Filtrar los elementos del carrito con el mismo mount_id y barcode
      const existingMounts = this.orden.  mounts.filter(
        (mount) =>
          mount.mount_id === payload.id && mount.barcode === payload.barcode
      );

      // Contar la cantidad actual en el carrito
      let totalInCart = existingMounts.length;
      let stockDisponible = payload.total_stock;

      // Verificar si la cantidad en el carrito supera el stock disponible
      if (totalInCart >= stockDisponible) {
        Swal.fire({
          icon: "warning",
          title: "Stock insuficiente",
          text: `Stock disponible: ${stockDisponible}. Ya has agregado ${totalInCart} a tu carrito, no puedes agregar más.`,
        });
        return;
      }

      // Asignar los valores si la validación pasa
      this.orden.mounts[pos].mount_name = payload.name;
      this.orden.mounts[pos].mount_id = payload.id;
      this.orden.mounts[pos].search_mount_name = "";
      this.orden.mounts[pos].mount_price = payload.precio_farmacia_particular;
      this.orden.mounts[pos].barcode = payload.barcode;
      this.orden.mounts[pos].dispatch_detail_id = payload.dispatch_detail_id;

      this.calculateSumMounts();
    },

    //Modal Lunas
    mtdAddLunas: function (num, item) {
      if (item.length > 2) {
        this.modalLunas = {
          title: "Lista de Tipos de Luna",
          modal_form: true,
          num: num,
          search: item,
        };
      } else {
        this.$refs.SweetAlert.showWarning(
          "Digite Tipo de Luna. Max 3 Caracteres"
        );
      }
    },

    closeModalLunas: function () {
      this.modalLunas = {
        title: "",
        modal_form: false,
        num: null,
        search: null,
      };
    },

    addLunas: function (payload, num) {
      if (num == 1) {
        this.orden.measure.far.lensType = payload.name;
        this.orden.measure.far.lensType_id = payload.id;
        this.orden.measure.far.search_lensType = "";
        this.orden.measure.far.lensType_price = payload.price;
      } else if (num == 2) {
        this.orden.measure.near.lensType = payload.name;
        this.orden.measure.near.lensType_id = payload.id;
        this.orden.measure.near.search_lensType = "";
        this.orden.measure.near.lensType_price = payload.price;
      }
      this.calculateSum();
    },
    closeModaltotal(){
      this.modaltotal= {
        title: "",
        modal_form: false,
        total: null,
      }
    },
  },
};
</script>
<style scoped>
.card-header {
  background-color: #2f395c !important;
}
.card {
  border-radius: 10px;
}
.table-bordered th,
.table-bordered td {
  vertical-align: middle;
}
.space {
  margin-left: 0.25rem;
}
.button-mount {
  font-size: 15px !important;
}
.payment {
  color: #2f395c;
}
.checked-switch {
  color: #4bbedd !important;
  border-color: #4bbedd !important;
}
.checked-switch:checked {
  background-color: #4bbedd !important;
  border-color: #4bbedd !important;
}

.input-switch {
  color: #2f395c !important;
  border-color: #2f395c !important;
}
.input-switch:checked {
  background-color: #2f395c !important;
  border-color: #2f395c !important;
}
</style>


  